import React from 'react';
import ViewMessage from '@components/ViewMessage';
import { ActionArchiveIcon } from '@repo/icons';
import { useSelector } from 'react-redux';
import { selectArchiveSearch } from '@repo/redux/reducers/data/archiveSearch';

export default function EmptyArchive() {
  const archiveSearch = useSelector(selectArchiveSearch);
  const hasTerm = !!archiveSearch.term && archiveSearch.term !== 'all';

  let headline = 'Archive';
  let message = (
    <>
      Once you archive someone,
      <br />
      You'll see them here
    </>
  );

  if (hasTerm) {
    headline = 'Archive Search';
    message = (
      <>
        No results were found for
        <br />"{archiveSearch.term}"
      </>
    );
  }

  return (
    <ViewMessage
      icon={<ActionArchiveIcon hoverOpacity={false} />}
      headline={headline}
      message={message}
    />
  );
}
